import { faBuildingColumns } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavMyOrg: () => NavRoute = () => {
	
	const organizationId: number | null = localStorage.getItem('organizationId') === null 
		? null
		: Number(localStorage.getItem('organizationId'));

	if (
		organizationId == null 
		|| organizationId == 0
	) {
		return {
			name: ''
			, path: ''
			, security: security => false
		};
	}
	
	return {
		name: 'Organization'
		, exact: true
		, path: `organizations/org/details/${organizationId}`
        , icon: faBuildingColumns
        , area: 'organizations'
		, expanded: globalThis.location.href.includes("/organizations/")
        , activeNavLink: 'organizations/org/details'
        , secondaryNav: ['Organization']
		, security: security => !security.manageOrganizations && security.manageSites
	};
};
